import axios from "axios";
import { generateTokenApiSignature } from "./signature";

let inFlightRefresh = null;

/**
 * Refreshes the SAT API access token.
 *
 * Deduplicates concurrent calls — only one in-flight refresh at a time.
 * On success stores new token in localStorage key `alfamindToken`.
 *
 * @returns {Promise<string>} New access token
 * @throws {Error} When `alfamindMemberId` missing or API response invalid
 */
export const refreshAccessToken = async () => {
  if (inFlightRefresh) {
    return inFlightRefresh;
  }

  const memberId = localStorage.getItem("alfamindMemberId");
  if (!memberId) {
    throw new Error("refreshAccessToken: alfamindMemberId missing");
  }

  const date = Date.now().toString();
  const signature = await generateTokenApiSignature(memberId, date);

  inFlightRefresh = axios
    .post(
      `${process.env.REACT_APP_SAT_API_URL}/user/v1/account/member/refreshToken`,
      { memberId, date },
      {
        headers: {
          "Content-Type": "application/json",
          signature,
        },
      },
    )
    .then((res) => {
      const token = res.data?.status?.token;
      if (res.data?.status?.code === "00" && token) {
        localStorage.setItem("alfamindToken", token);
        return token;
      }
      throw new Error("refreshAccessToken: invalid response");
    })
    .finally(() => {
      inFlightRefresh = null;
    });

  return inFlightRefresh;
};
